import React, { useState } from 'react';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

type DropdownProps = {
    className?: string;
    data: any[];
    dataKey?: string;
    onSelect: (value: any) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    value?: any;
}

function Dropdown({
    className,
    data,
    dataKey,
    onSelect,
    label,
    placeholder,
    required,
    value
}: DropdownProps) {
    const [isFocused, setIsFocused] = useState(false);

    const ref = useOutsideClickHandler(() => setIsFocused(false));

    const selectItem = (item: any) => {
        onSelect(item);
        setIsFocused(false);
    }

    return (
        <div
            className={value || isFocused
                ? `dropdown--focused ${className}`
                : `dropdown ${className}`
            } 
            onClick={() => setIsFocused(!isFocused)}
            ref={ref}
        >
            {label &&
                <p className='dropdown__label'>
                    {label} {required && '*'}
                </p>
            }
            {value
              ? <p>{value}</p>
              : placeholder
              ? <p className='dropdown__placeholder'>
                    {placeholder}
                </p>
              : <></>
            }
            <div className={isFocused
                ? 'dropdown__items'
                : 'dropdown__items--hidden'
            }>
                {data.map((item, i) => (
                    <div
                        key={i} 
                        className='dropdown__item'
                        onClick={() => selectItem(item)}
                    >
                        {dataKey ? item[dataKey] : item}
                    </div>
                ))}
            </div>
            {isFocused
                ? <FaCaretUp className='dropdown__icon' />
                : <FaCaretDown className='dropdown__icon' />
            }
        </div>
    );
}

export default Dropdown;